module.exports = __webpack_public_path__ + "img/pic05@2x.4f41794c.png";